import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styles from './AdminButton.module.sass';

export const AdminButton = () => {
  const isOrganizer = useSelector((state) => state.get('contactInfo')?.get('isOrganizer')) || false;
  const editUrl = useSelector((state) => state.get('route')?.get('edit_url')) || "";
  const { t } = useTranslation();

  if(!isOrganizer) return null;

  return (
    <div className={styles.AdminButton}>
      <a href={editUrl}>
        {t('route.adminButton.cta')}
      </a>
    </div>
  );
};
